// src/config/site.ts
export const SITE_URL =
  import.meta.env.PROD
    ? "https://www.ridecorelatam.com"
    : "http://localhost:5173";